import gql from 'graphql-tag';

const STOP_EVENT_DEBUGGING = gql`
  mutation StopEventDebugging {
    stopEventDebugging
  }
`;

export default STOP_EVENT_DEBUGGING;
